import { render, staticRenderFns } from "./complicacionesIdentificadas.vue?vue&type=template&id=c4a5288e"
import script from "./complicacionesIdentificadas.vue?vue&type=script&lang=js"
export * from "./complicacionesIdentificadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports